import { Select as AntdSelect } from 'antd'
import styled from '@emotion/styled'

export const Select = styled(AntdSelect)`
  .ant-select-selector {
    height: 60px !important;
    display: flex;
    align-items: center;
  }

  .ant-select-selection-item {
    height: 60px !important;
    display: flex;
    align-items: center;
  }
`

export const Option = styled(AntdSelect.Option)``
